import * as React from 'react';
import { Component } from 'react';
import { enableRipple } from '@syncfusion/ej2-base';
import {
  TreeViewComponent,
  ContextMenuComponent,
} from '@syncfusion/ej2-react-navigations';
import {
  DialogComponent,
  ButtonPropsModel,
  AnimationSettingsModel,
} from '@syncfusion/ej2-react-popups';
import { DropDownListComponent } from '@syncfusion/ej2-react-dropdowns';
import {
  IoAddSharp,
  IoRefresh,
  IoTrashOutline,
  IoCheckmarkDoneOutline,
} from 'react-icons/io5';
import './style.css';
import {
  ColorPickerComponent,
  TextBoxComponent,
} from '@syncfusion/ej2-react-inputs';
import Scheduler from '../../components/GlobalScheduler';
import Message from '../../utils/Message/Message';
import { all_information, loadingShow } from '../../App';
import { toast } from 'react-toastify';
import {
  getAssignmentsDetails,
  setterTeamAndTradeToAssignment,
} from '../../services/assignments/assignmentService';
import { ThemeContext } from '../../context/theme.context';
import {
  GetAllTrades,
  getTradeAssignmentDetail,
  GetAssignmentOfTheTrade,
  GetTrades,
} from '../../services/TradePlanner/Trades/TradesServices';
import {
  createTrade,
  getTrades,
  getTradesDetail,
  tradeUpdate,
  tradeDelete,
  GetById,
  tradeDeleteList,
} from '../../services/tradeperson/trades';
import { getTeams } from '../../services/tradeperson/team';
import TeamAndTradeSetter from '../../utils/TeamAndTradeSetter';
import GenerateCapacity from '../../utils/GenerateCapacity';
import { searchNodes } from '../../utils/GetFilterItems';
type Fields = {
  dataSource: any;
  id: any;
  parentID: any;
  text: any;
  hasChildren: any;
  htmlAttributes: any;
};
interface IProps {}
interface IState {
  fields: Fields;
  allowDragAndDrop: boolean;
  allowMultiSelection: boolean;
  arrivedData: any;
  hideDialog: boolean;
  TradesData: any;
  isException: boolean;
  hideDialogTradesAdd: boolean;
  hideDialogTradesEdit: boolean;
  hideDialogTradesDelete: boolean;
  tradeTeamSetVisible: boolean;
  hideDialogAssignTeams: boolean;
  isAssign: boolean;
  pickedTradeId: any;
  teamsAssignData: any;
  selectedTeam: any;
  roosterData: any;
  selectedAssignments: Array<any>;
  tradeNamesNeedsToDelete: [];
}
export default class Trade extends Component<IProps, IState> {
  public tradeNamesNeedsToDelete: string[] | undefined;
  public menuObj: any;
  public treeObj: any;
  public menuItems: any;
  public menuItems2: any;
  private buttonsTradeToTeam: ButtonPropsModel[];
  private buttonsTradesAdd: ButtonPropsModel[];
  private buttonsTradesEdit: ButtonPropsModel[];
  private buttonsTradesDelete: ButtonPropsModel[];
  private animationSettings: AnimationSettingsModel;
  public dialogInstance: any;
  public buttonEle: any;
  public selectedName: string;
  private isChecked: boolean = true;
  boolean = true;
  private checkedNodes: Array<any> = [];
  private assignmentId: string;
  static selectedNodeList: Array<any> = [];
  private incomingCurrentAssignData: Array<any> = [];
  private inputName: string = '';
  private inputDescription: string = '';
  private tradeID: number = -1;
  static contextType = ThemeContext;
  context!: React.ContextType<typeof ThemeContext>;
  // description
  private fieldsAssignTeam = { text: 'team_code', value: 'team_id' };
  private selectName = '';
  private valueOfColorPicker: any = '#000000';
  private tradeDataForFilterColor: Array<any> = [];
  private current_trade_ids: any = [];
  constructor(props: IProps) {
    super(props);
    this.treeObj = new TreeViewComponent(props);
    this.menuObj = new ContextMenuComponent(props);
    this.dialogInstance = new DialogComponent(props);
    this.selectedName = '';
    this.assignmentId = '';
    this.buttonsTradesAdd = [
      {
        click: () => {
          this.createTrade();
        },
        buttonModel: {
          content: 'Save',
          isPrimary: true,
        },
      },
      {
        click: () => {
          this.setState({ hideDialogTradesAdd: false });
        },
        buttonModel: {
          content: 'Cancel',
        },
      },
    ];
    this.buttonsTradesEdit = [
      {
        click: () => {
          this.editTrade();
        },
        buttonModel: {
          content: 'Save',
          isPrimary: true,
        },
      },
      {
        click: () => {
          this.setState({ hideDialogTradesEdit: false });
        },
        buttonModel: {
          content: 'Cancel',
        },
      },
    ];
    this.buttonsTradesDelete = [
      {
        click: () => {
          this.deleteTrade();
        },
        buttonModel: {
          content: 'Yes',
          isPrimary: true,
        },
      },
      {
        click: () => {
          this.setState({ hideDialogTradesDelete: false });
        },
        buttonModel: {
          content: 'No',
        },
      },
    ];
    this.buttonsTradeToTeam = [
      {
        click: () => {
          this.saveTradeToTeam();
        },
        buttonModel: {
          content: 'Save',
          isPrimary: true,
        },
      },
      {
        click: () => {
          this.setState({ hideDialogAssignTeams: false });
        },
        buttonModel: {
          content: 'Cancel',
        },
      },
    ];
    this.animationSettings = { effect: 'Zoom', duration: 400, delay: 0 };
    Scheduler.StoreTrades = [];
    this.state = {
      tradeNamesNeedsToDelete: [],
      pickedTradeId: '',
      TradesData: [],
      fields: {
        dataSource: [],
        id: '',
        parentID: '',
        text: '',
        hasChildren: '',
        htmlAttributes: '',
      },
      allowDragAndDrop: true,
      arrivedData: null,
      allowMultiSelection: true,
      hideDialog: false,
      isException: false,
      hideDialogTradesAdd: false,
      hideDialogTradesDelete: false,
      hideDialogTradesEdit: false,
      hideDialogAssignTeams: false,
      tradeTeamSetVisible: false,
      isAssign: true,
      teamsAssignData: [],
      selectedTeam: '',
      roosterData: [],
      selectedAssignments: [],
    };
    this.menuItems = [
      { text: 'Assign Shift Element' },
      { text: 'Assign to a Team' },
    ];
    this.menuItems2 = [
      { text: 'Assign Shift Element' },
      { text: 'Assign to a Team/Trade' },
    ];
  }
  componentDidMount() {
    this.getTradeByAssigment();
    this.getTeamsData();
    this.getTradesForColor();
  }
  getTeamsData() {
    getTeams().then((res) => {
      this.setState({ teamsAssignData: res.data });
    });
  }
  setTradeTeamAffected = () => {
    this.context.setDataChangeTrade(true);
    this.context.setDataChangeTeam(true);
    this.context.setDataChange(true);
  };
  saveTradeToTeam() {
    var teamId = this.state.selectedTeam;
    var trades = this.selectedName;
    if (trades.includes(',')) {
      trades = trades.split(',')[0].trim() + ',' + trades.split(',')[1].trim();
    }
    var teamCode = $('#assignTeamId').val();
    if (this.current_trade_ids[0].trade_id === null) {
      Message.error('Please select a single trade to procced.');
      return;
    }
    if (!teamCode) {
      Message.error('team code cannot be empty!!!');
      return false;
    }
    loadingShow(true);
    getTradeAssignmentDetail(this.current_trade_ids[0].trade_id)
      .then((res) => {
        this.setState({ hideDialogAssignTeams: false });
        const obj = [
          ...res.data?.map((el: any) => {
            return {
              ...el,
              teams: {
                assignment_id: el.assignment_id,
                team_id: teamId,
                team_code: teamCode,
                app: 'UWORK',
                user_id: all_information.user_id,
                organization_id: all_information.company_id?.toString(),
                creation_date: new Date(),
                created_by: all_information.user_id,
              },
              trades: {
                assignment_id: el.assignment_id,
                trade_code: trades,
                trade_id: this.current_trade_ids[0].trade_id,
                app: 'UWORK',
                user_id: all_information.user_id,
                organization_id: all_information.company_id?.toString(),
                creation_date: new Date(),
                created_by: all_information.user_id,
              },
            };
          }),
        ];
        setterTeamAndTradeToAssignment(obj)
          .then((resSetTrade) => {
            if (resSetTrade.data.message) {
              Message.error(resSetTrade.data.message);
            } else {
              Message.success('Added Successfully');
              this.context.setDataChangeTeam(true);
            }
            loadingShow(false);
          })
          .catch((err) => {
            if (err.response) {
              Message.error(
                err.response.data +
                  '\n' +
                  err.response.status +
                  '\n' +
                  err.response.headers
              );
            } else if (err.request) {
              Message.error(err.request);
            } else {
              Message.error('Error: ' + err.message);
            }
            loadingShow(false);
          });
      })
      .catch((err) => {
        loadingShow(false);
        this.setState({ hideDialogAssignTeams: false });
      });
  }
  componentDidUpdate() {
    if (this.context.isDataChangeTrade) {
      this.getTradeByAssigment();
      this.context.setDataChangeTrade(false);
    }
    if (this.context.isDataChangeTeam) {
      this.context.setDataChangeTeam(false);
    }
  }
  getTradeByAssigment() {
    GetTrades().then((res) => {
      var data = res.data.map((result: any) => {
        return {
          ...result,
          htmlAttributes: {
            trade_id: JSON.stringify([{ trade_id: result.trade_id }]),
            description: JSON.stringify([
              { description: result.trade_description },
            ]),
          },
        };
      });
      var model = {
        dataSource: data,
        id: 'id',
        parentID: 'pid',
        text: 'name',
        hasChildren: 'hasChild',
        htmlAttributes: 'htmlAttributes',
      };
      this.setState({ fields: model, TradesData: res.data });
    });
  }
  getTradesForColor() {
    GetAllTrades().then((res) => {
      this.tradeDataForFilterColor = res.data;
    });
  }
  nodeclicked(args: any) {
    this.current_trade_ids = JSON.parse(args.node.getAttribute('trade_id'));
    if (args.event.which === 3) {
      this.assignmentId = args.node.getAttribute('data-uid');
      this.treeObj.selectedNodes = [args.node.getAttribute('data-uid')];
      if (parseInt(this.treeObj.selectedNodes[0]) < 10000) {
        this.setState({ isAssign: false });
      } else {
        this.setState({ isAssign: true });
      }
      this.selectedName = args.node.innerText.split('\n')[0];
    }
  }
  menuclick(args: any) {
    if (args.item !== undefined) {
      if (args.item.text === 'Assign Shift Element') {
        var theTreeObj = this.treeObj as TreeViewComponent;
        if (theTreeObj.selectedNodes.length > 0) {
          if (this.treeObj.getAllCheckedNodes().length > 0) {
            this.state.TradesData?.map((trade: any) => {
              this.treeObj.getAllCheckedNodes().map((node: any) => {
                if (trade.id === parseInt(node) && trade.pid === null) {
                  if (node === null) {
                    Message.error('Please select a single trade to procced.');
                    return;
                  }
                  this.current_trade_ids[0].trade_id = trade.trade_id;
                }
              });
            });
          }

          if (this.current_trade_ids[0].trade_id === null) {
            Message.error('Please select a single trade to procced.');
            return;
          }
          if (this.current_trade_ids[0].trade_id) var filteredIds: any[] = [];
          GetAssignmentOfTheTrade(this.current_trade_ids[0].trade_id)
            .then((res) => {
              // let theIds = [
              //   ...res.data.map((el: any) => el.assignment_id),
              // ].toString();
              let theIds: any[] = this.treeObj.getAllCheckedNodes();
              let theparentIds: any[] = [];

              this.treeObj?.treeData?.map((item: any) => {
                if (item.hasChild === true) {
                  theparentIds.push(item.id);
                }
              });

              // if(theIds.length >0){
              //   theIds.reverse().pop()
              // }

              theIds.map((theId: any) => {
                if (
                  !theparentIds.includes(parseInt(theId)) &&
                  !filteredIds.includes(theId)
                ) {
                  filteredIds.push(theId);
                }
              });
              getAssignmentsDetails(filteredIds)
                .then((response) => {
                  loadingShow(false, 'Preparing...');
                  this.setState({
                    selectedAssignments: response.data,
                    hideDialog: true,
                  });
                  this.setState({ hideDialog: true });
                })
                .catch((e: any) => {
                  //(e);
                  toast.error('Error occured.Please try again later');
                  loadingShow(false, 'Preparing...');
                });
              loadingShow(false);
            })
            .catch((er) => {
              if (er.response) {
                Message.error(er.response.data);
                Message.error(er.response.status);
                Message.error(er.response.headers);
              } else if (er.request) {
                Message.error(er.request);
              } else {
                Message.error('Error: ' + er.message);
              }
              Message.error(er.config);
            });
        }
      } else if (args.item.text === 'Trades Exception') {
      } else if (args.item.text === 'Assign to a Team') {
        this.setState({ hideDialogAssignTeams: true });
      } else if (args.item.text === 'Assign to a Team/Trade') {
        loadingShow(true, 'Preparing...');
        getAssignmentsDetails(this.assignmentId)
          .then((response: any) => {
            loadingShow(false, 'Preparing...');
            this.incomingCurrentAssignData.push(response.data);
            this.setState({
              tradeTeamSetVisible: true,
            });
          })
          .catch((e: any) => {
            toast.error('Error occured.Please try again later');
            loadingShow(false, 'Preparing...');
          });
      }
    }
  }
  nodeChecked(args: any) {
    if (args.action === 'check') {
      Scheduler.StoreTrades.push(args.data[0].text);
    } else {
      Scheduler.StoreTrades.splice(
        Scheduler.StoreTrades.indexOf(args.data[0].text),
        1
      );
    }
  }
  createTrade() {
    var tradeCode = this.inputName;
    var tradeDescription = this.inputDescription;
    var isExistBefore = this.tradeDataForFilterColor.findIndex((el) => {
      return el.color === this.valueOfColorPicker;
    });
    if (isExistBefore !== -1) {
      toast.error('Color must be uniq');
      loadingShow(false);
      return false;
    }

    if (tradeCode === '') {
      toast.error('Trade Name cannot be empty');
      loadingShow(false);
      return false;
    }
    if (tradeDescription === '') {
      toast.error('Trade Description cannot be empty');
      loadingShow(false);
      return false;
    }

    let obj = {
      trade_code: tradeCode,
      description: tradeDescription,
      color: this.valueOfColorPicker,
      app: 'UWORK',
      created_by: all_information.user_id,
      organization_id: all_information.company_id?.toString(),
      creation_date: new Date(),
    };

    createTrade(obj)
      .then((result) => {
        loadingShow(false);
        Message.success('Added successfully...');
        this.setState({ hideDialog: false, hideDialogAssignTeams: false });
        this.getTradeByAssigment();
        this.getTradesForColor();
      })
      .catch((err) => {
        loadingShow(false);
        Message.error('Add failed!!!');
      });

    this.setState({ hideDialogTradesAdd: false });
  }
  refreshFunction() {
    this.checkedNodes = [];
    Scheduler.StoreTrades = [];
    this.treeObj.uncheckAll();
    this.getTradeByAssigment();
    this.context.setDataChangeTrade(false);
  }
  deleteTrade() {
    var tradesNeedsToDelete: { trade_id: number }[] = [];
    this.tradeNamesNeedsToDelete = this.processList(Scheduler.StoreTrades);
    getTrades().then((e) => {
      var response = e.data;
      try {
        this.tradeNamesNeedsToDelete?.map(
          (eachTradeNameNeedsToDeleteObject: string) => {
            response.map(
              (eachTradeObject: { trade_code: string; trade_id: number }) => {
                if (
                  eachTradeNameNeedsToDeleteObject == eachTradeObject.trade_code
                ) {
                  let obj = {
                    trade_id: eachTradeObject.trade_id,
                  };
                  tradesNeedsToDelete.push(obj);
                }
              }
            );
          }
        );
        tradeDeleteList(tradesNeedsToDelete);
        Message.success('Deleted successfully...');
      } catch (error) {
        console.log(error);
        Message.error('Error');
      }
    });
    this.setState({ hideDialogTradesDelete: false });
    this.refreshFunction();
  }

  editTrade() {
    var tradeCode = this.inputName;
    var tradeDescription = this.inputDescription;
    var isExistBefore = this.tradeDataForFilterColor.findIndex((el) => {
      return el.color === this.valueOfColorPicker;
    });
    if (tradeCode === '') {
      toast.error('Trade Name cannot be empty');
      loadingShow(false);
      return false;
    }
    if (tradeDescription === '') {
      toast.error('Trade Description cannot be empty');
      loadingShow(false);
      return false;
    }
    if (
      isExistBefore !== -1 &&
      this.tradeDataForFilterColor[isExistBefore].trade_id !== this.tradeID
    ) {
      toast.error('Color must be uniq');
      loadingShow(false);
      return false;
    }

    let obj = {
      trade_id: this.tradeID,
      trade_code: tradeCode,
      trade_description: tradeDescription,
      trade_color: this.valueOfColorPicker,
      ...all_information,
    };

    tradeUpdate(obj)
      .then((result) => {
        if (result.status === 200) {
          loadingShow(false);
          Message.success('Edited successfully...');
          this.setState({ hideDialogTradesEdit: false });
          this.getTradeByAssigment();
          this.getTradesForColor();
          this.context.setDataChangeKpiTrade(true);
          this.context.setDataChangeKpiTeam(true);
          this.context.setDataChangeKpiTradePerson(true);
        }
      })
      .catch((err) => {
        loadingShow(false);
        Message.error('Editing failed!!!');
      });
  }
  EditTradeOpenModal = () => {
    var theTreeObj = this.treeObj as TreeViewComponent;
    if (theTreeObj.selectedNodes.length > 0) {
      loadingShow(true, 'Preparing...');
      var data = theTreeObj.getNode(theTreeObj.selectedNodes[0]);

      getTradesDetail(data.text?.toString())
        .then((e) => {
          loadingShow(false);
          if (Number(data.id) >= 100000) {
            if (e.data.length > 0) {
              this.tradeID = e.data[0].trade_id;
              this.inputName = e.data[0].trade_code;
              this.inputDescription = e.data[0].description;
              this.valueOfColorPicker = e.data[0].color;
              this.setState({ hideDialogTradesEdit: true });
            } else {
              Message.error('No allowed edit for multitrade');
            }
          } else {
            Message.error('No allowed edit for child of trade');
          }
        })
        .catch((e) => {
          loadingShow(false);
          Message.error('Error occured');
        });
    } else {
      Message.error('No selected any trades to edit');
    }
  };
  processList = (list: string[]): string[] => {
    // Bir Set kullanarak benzersiz öğeleri toplayacağız
    const uniqueItems = new Set<string>();

    list.forEach((item) => {
      // Öğeleri virgülle ayır ve "-" karakterlerini kaldır
      const items = item.replace(/-/g, '').split(',');

      items.forEach((subItem) => {
        uniqueItems.add(subItem.trim());
      });
    });

    // Set'i diziye dönüştürüp geri döndür
    return Array.from(uniqueItems);
  };
  DeleteTradeModal = () => {
    var theTreeObj = this.treeObj as TreeViewComponent;

    if (this.current_trade_ids.length > 0) {
      loadingShow(true, 'Preparing...');
      //var data = theTreeObj.getNode(theTreeObj.selectedNodes[0]);
      GetById(this.current_trade_ids[0].trade_id)
        .then((e) => {
          loadingShow(false);

          if (e?.data) {
            this.tradeID = e.data.trade_id;
            this.setState({ hideDialogTradesDelete: true });
          } else {
            this.setState({ hideDialogTradesDelete: true });
          }
        })
        .catch((e) => {
          loadingShow(false);
          Message.error('Error occured');
        });
    } else {
      Message.error('No selected any trades to delete');
    }
  };
  changeDataSource(data: any) {
    this.setState({
      fields: {
        dataSource: data,
        id: 'id',
        parentID: 'pid',
        text: 'name',
        hasChildren: 'hasChild',
        htmlAttributes: 'htmlAttributes',
      },
    });
  }
  searchNodes(args: any) {
    searchNodes(
      args.value,
      this.state.TradesData,
      this.changeDataSource.bind(this),
      'name',
      'id'
    );
  }

  nodeTemplate = (data: any) => {
    // if (!data || !data.htmlAttributes?.description) {
    //   console.log('if girdi');
    //   return (
    //     <div>
    //       <span className='e-list-text'>{data.name}</span>
    //     </div>
    //   );
    // }
    // let theData = JSON.parse(data.htmlAttributes?.description);
    console.log('data');
    console.log(data);
    let desc: string = '';
    if (data.description != null) {
      desc = data.description;
    }
    // let theData;
    // data.htmlAttributes != undefined
    //   ? (theData = JSON.parse(data.htmlAttributes.description))
    //   : (theData = [{ description: data.description }]);
    // let description = theData[0].description
    //   ? ` - ${theData[0].description}`
    //   : data.description
    //   ? ` - ${data.description}`
    //   : '';
    return (
      <div>
        <span className='e-list-text'>{data.name}</span>
        <span className='e-list-text'>
          {' '}
          {desc == '' ? '' : '-' + '            ' + desc}{' '}
        </span>
      </div>
    );
  };

  render() {
    return (
      <div>
        <div className='trades-header-crud'>
          <h5 className='trades-baslik'>TRADES</h5>
          <div className='trade-crud'>
            <div className='add-trade'>
              <IoAddSharp
                onClick={() => this.setState({ hideDialogTradesAdd: true })}
                size={17}
              />
            </div>
            {/* <div className='edit-trade'>
              <GoPencil onClick={this.EditTradeOpenModal} size={17} />
            </div> */}
            <div className='delete-trade'>
              <IoTrashOutline onClick={this.DeleteTradeModal} size={17} />
            </div>
            <div className='refresh-trade'>
              <IoRefresh
                onClick={() => {
                  this.refreshFunction();
                }}
                size={17}
              />
            </div>
            <div className='uncheck-trade'>
              <IoCheckmarkDoneOutline
                onClick={() => {
                  this.checkedNodes = [];
                  Scheduler.StoreTrades = [];
                  this.treeObj.uncheckAll();
                }}
                size={17}
              />
            </div>
          </div>
        </div>
        <div className='searchAssign'>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              alignSelf: 'flex-end',
              height: 25,
            }}
          >
            <TextBoxComponent
              type={'text'}
              id='trades_search'
              autocomplete='off'
              // input={this.searchNodes.bind(this)}
              showClearButton
              placeholder='Search'
              onChange={this.searchNodes.bind(this)}
            />
            <div
              style={{
                borderRightColor: 'transparent',
                borderTopColor: 'transparent',
                borderBottomColor: 'transparent',
              }}
            ></div>
          </div>
        </div>
        <div className='trades-treeview'>
          <TreeViewComponent
            className='treeTrades123'
            id='treeTrades'
            fields={this.state.fields}
            allowMultiSelection={false}
            allowDragAndDrop={false}
            ref={(treeview) => {
              this.treeObj = treeview as TreeViewComponent;
            }}
            nodeClicked={this.nodeclicked.bind(this)}
            showCheckBox={this.isChecked}
            nodeChecked={this.nodeChecked}
            dragArea={document.getElementById('SplitterInner') as HTMLElement}
            nodeTemplate={this.nodeTemplate}
          />
          <ContextMenuComponent
            id='contentmenutree'
            target='#treeTrades'
            items={this.state.isAssign ? this.menuItems : this.menuItems2}
            select={this.menuclick.bind(this)}
            ref={(contextmenu) => {
              this.menuObj = contextmenu;
            }}
          />
          <div className='control-pane-dialog'>
            <div
              id='targetElement'
              className='col-lg-12 defaultDialog dialog-target'
            >
              {this.state.hideDialog ? (
                <GenerateCapacity
                  assignments={this.state.selectedAssignments}
                  hideDialog={this.state.hideDialog}
                  setHideDialogCapacity={(val) =>
                    this.setState({ hideDialog: val })
                  }
                />
              ) : null}
            </div>
          </div>
          <div className='control-pane-dialog'>
            <div
              id='targetElement'
              className='col-lg-12 defaultDialog dialog-target'
            >
              {this.state.hideDialogAssignTeams ? (
                <DialogComponent
                  style={{ marginBottom: '200px' }}
                  isModal={true}
                  id='defaultdialog'
                  showCloseIcon={true}
                  animationSettings={this.animationSettings}
                  visible={this.state.hideDialogAssignTeams}
                  width={'500px'}
                  ref={(dialog) => (this.dialogInstance = dialog)}
                  header='Assign Teams'
                  buttons={this.buttonsTradeToTeam}
                  open={() => this.setState({ hideDialogAssignTeams: true })}
                  close={() =>
                    this.setState({
                      hideDialog: false,
                      hideDialogAssignTeams: false,
                    })
                  }
                >
                  <div className='row'>
                    <div className='col-md-12' style={{ marginBottom: '10px' }}>
                      <div className='col-md-3'>Trade Name</div>
                      <div className='col-md-9'>{this.selectedName}</div>
                    </div>
                    <div className='col-md-12'>
                      <div className='col-md-3'>Teams Name</div>
                      <div className='col-md-9'>
                        <DropDownListComponent
                          id='assignTeamId'
                          dataSource={this.state.teamsAssignData}
                          onChange={(e: any) =>
                            this.setState({ selectedTeam: e.value })
                          }
                          fields={this.fieldsAssignTeam}
                          placeholder='Select a Teams'
                        />
                      </div>
                    </div>
                  </div>
                </DialogComponent>
              ) : null}
            </div>
          </div>
          <div className='control-pane-dialogAdd'>
            <div
              id='targetElementAddTrades'
              className='col-lg-12 defaultDialogAddTrades dialog-target'
            >
              {this.state.hideDialogTradesAdd ? (
                <DialogComponent
                  isModal={true}
                  id='defaultDialogAddTrades'
                  showCloseIcon={true}
                  animationSettings={this.animationSettings}
                  visible={this.state.hideDialogTradesAdd}
                  width={'400px'}
                  height={'auto'}
                  header='Add Trades'
                  buttons={this.buttonsTradesAdd}
                  open={() => this.setState({ hideDialogTradesAdd: true })}
                  close={() => this.setState({ hideDialogTradesAdd: false })}
                >
                  <div className='row mb-3'>
                    <div className='col-md-3'>Name:</div>
                    <div className='col-md-9'>
                      <TextBoxComponent
                        input={(e) => {
                          this.inputName = e.value;
                        }}
                        placeholder='Enter a Name'
                      />
                    </div>
                  </div>
                  <div className='row mb-3'>
                    <div className='col-md-3'>Description:</div>
                    <div className='col-md-9'>
                      <TextBoxComponent
                        input={(e) => {
                          this.inputDescription = e.value;
                        }}
                        placeholder='Enter description'
                      />
                    </div>
                  </div>
                  <div className='row mb-3'>
                    <div className='col-md-3'>Colour:</div>
                    <div className='col-md-9'>
                      <ColorPickerComponent
                        mode='Picker'
                        value={this.valueOfColorPicker}
                        change={(e: any) => {
                          this.valueOfColorPicker = e.value;
                        }}
                      />
                    </div>
                  </div>
                </DialogComponent>
              ) : null}

              {this.state.hideDialogTradesEdit ? (
                <DialogComponent
                  isModal={true}
                  id='defaultDialogAddTrades'
                  showCloseIcon={true}
                  animationSettings={this.animationSettings}
                  visible={this.state.hideDialogTradesEdit}
                  width={'400px'}
                  height={'auto'}
                  header='Edit Trades'
                  buttons={this.buttonsTradesEdit}
                  open={() => {
                    this.setState({ hideDialogTradesEdit: true });
                  }}
                  close={() => this.setState({ hideDialogTradesEdit: false })}
                >
                  <div className='row mb-3'>
                    <div className='col-md-3'>Name:</div>
                    <div className='col-md-9'>
                      <TextBoxComponent
                        input={(e) => {
                          this.inputName = e.value;
                        }}
                        placeholder='Enter a Name'
                        value={this.inputName}
                      />
                    </div>
                  </div>
                  <div className='row mb-3'>
                    <div className='col-md-3'>Description:</div>
                    <div className='col-md-9'>
                      <TextBoxComponent
                        input={(e) => {
                          this.inputDescription = e.value;
                        }}
                        placeholder='Enter description'
                        value={this.inputDescription}
                      />
                    </div>
                  </div>
                  <div className='row mb-3'>
                    <div className='col-md-3'>Colour:</div>
                    <div className='col-md-9'>
                      <ColorPickerComponent
                        mode='Picker'
                        value={this.valueOfColorPicker}
                        change={(e: any) => {
                          this.valueOfColorPicker = e.value;
                        }}
                      />
                    </div>
                  </div>
                </DialogComponent>
              ) : null}

              {this.state.hideDialogTradesDelete ? (
                <DialogComponent
                  isModal={true}
                  id='defaultDialogAddTrades'
                  showCloseIcon={true}
                  animationSettings={this.animationSettings}
                  visible={this.state.hideDialogTradesDelete}
                  width={'400px'}
                  height={'auto'}
                  header='Delete Trades'
                  buttons={this.buttonsTradesDelete}
                  open={() => {
                    this.setState({ hideDialogTradesDelete: true });
                  }}
                  close={() => this.setState({ hideDialogTradesDelete: false })}
                >
                  <p>Are you sure?</p>
                </DialogComponent>
              ) : null}
              {this.state.tradeTeamSetVisible ? (
                <TeamAndTradeSetter
                  affected={() => {
                    this.context.setDataChangeTrade(true);
                    this.setTradeTeamAffected();
                  }}
                  assignment_list={
                    Scheduler.StoreAssign.length > 0
                      ? Scheduler.StoreAssign
                      : [this.assignmentId]
                  }
                  hideDialogOrder={this.state.tradeTeamSetVisible}
                  setHideDialogSetter={(val: boolean) =>
                    this.setState({ tradeTeamSetVisible: val })
                  }
                />
              ) : null}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
